import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b4e2824c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e2824c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b4e2824c')) {
      api.createRecord('b4e2824c', component.options)
    } else {
      api.reload('b4e2824c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=b4e2824c&scoped=true", function () {
      api.rerender('b4e2824c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderCenter/kanbanPlatform/sortingDataMonitoring/index.vue"
export default component.exports